<template>
    <div class="client-logo" :title="name">
        <component class="u-reset client-logo--link"
                :is="linkComponent"
                :path="link"
                :external="true">
            <dyn-picture-element v-bind="image"/>
        </component>
    </div>
</template>

<script>
    import ConditionalLink from 'framework/components/conditional-link/conditional-link';

    export default {
        components: { ConditionalLink },
        props: {
            name: {
                type: String,
                required: true,
            },

            link: {
                type: String,
                default: null,
            },

            /**
             * @type {ISvgImageSet}
             */
            image: {
                type: Object,
                required: true,
            },
        },
        computed: {
            linkComponent() {
                if (this.link) {
                    return 'conditional-link';
                }
                return 'span';
            },
        },
    };
</script>
